import React from 'react';

import { Popover, Card, CardHeader, CardContent } from '@gogame/components';

import StatusSchedulesLogs from 'scenes/Gallery/GalleryPage/Concepts/components/StatusSchedulesLogs';

const PlannedSchedule = ({ data, icon, title }) => {
  return (
    <Popover
      hover={true}
      anchor={icon}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'right',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'left',
      }}
    >
      <Card elevation={6} style={{ minWidth: 160 }}>
        {title && (
          <CardHeader
            title={'Schedule'}
            titleTypographyProps={{ variant: 'subtitle1' }}
          />
        )}
        <CardContent>
          <StatusSchedulesLogs data={data} />
        </CardContent>
      </Card>
    </Popover>
  );
};
export default PlannedSchedule;
